module.exports = __webpack_public_path__ + "img/swiper_2.4c06de59.jpg";